import { Box, Divider, Grid, Typography } from "@mui/material";
import { FC } from "react";
import BackButton from "./BackButton";

interface Props {
  titulo: string;
  descripcion: string;
  img: string;
  alt: string;
  primaryColor: string;
  secondaryColor: string;
  thirdColor: string;
  backButton?: string;
  secondPercentage?: string;
}

const HeaderCategoria: FC<Props> = ({
  titulo,
  descripcion,
  img,
  alt,
  primaryColor,
  secondaryColor,
  thirdColor,
  backButton,
  secondPercentage,
}) => {
  return (
    <Grid
      container
      sx={{
        width: "100%",
        minHeight: "300px",
        borderRadius: 3,
        backgroundImage: `linear-gradient(360deg, #FCFCFC 0%, ${secondaryColor} ${
          secondPercentage ?? 100
        }%, ${thirdColor} 100%)`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        p: { xs: 2, md: 3 },
        display: "flex",
        alignItems: "center",
        flexDirection: { xs: "column", md: "row" },
        position: "relative",
        gap: { xs: 4, md: 5 },
        mt: { xs: 1, md: 0 },
        flexWrap: "nowrap",
      }}
    >
      {/* Botón de regresar */}
      <Grid item xs={2} sm={1}>
        <BackButton
          route="/asistente/menu"
          color={backButton ?? primaryColor}
        />
      </Grid>

      {/* Imagen */}
      <Grid item xs={10} sm={4} md={3}>
        <Box
          component="img"
          src={img}
          alt={alt}
          sx={{
            maxWidth: { xs: "150px", sm: "200px", md: "250px" },
            height: "auto",
            objectFit: "contain",
            aspectRatio: 4 / 3,
            width: "100%",
          }}
        />
      </Grid>

      {/* Texto y divisor */}
      <Grid
        item
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          alignItems: { xs: "center", md: "flex-start" },
        }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          color={primaryColor}
          fontFamily={"Montserrat"}
          sx={{
            fontSize: { xs: "1.25rem", sm: "2rem", md: "3rem", lg: "4rem" },
          }}
        >
          {titulo}
        </Typography>
        <Divider
          sx={{
            width: { xs: "50px", md: "60px" },
            height: "4px",
            backgroundColor: primaryColor,
            borderRadius: 2,
          }}
        />
        <Typography
          variant="body1"
          color="rgba(0, 0, 0, 0.6)"
          fontSize={{ xs: "0.9rem", sm: "1.1rem", md: "1.3rem", lg: "1.5rem" }}
          sx={{
            fontWeight: "medium",
            fontFamily: "Montserrat",
            textAlign: { xs: "center", md: "left" },
            lineHeight: { xs: 1.2, md: 1.4 },
            maxWidth: { xs: "100%", xl: "70%" },
          }}
        >
          {descripcion}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default HeaderCategoria;
